import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type { ExpectedEodSwapSnapshotDto } from '@/api/types/riskDashboard';
import type {
  DailySnapshotListDto,
  LPAccountSnapshotDto,
  LPAccountTotalsDto,
  LpEodPositionDto,
  NopDailySnapshotListDto,
  NopSnapshotDto,
  NopSnapshotNotificationsDto,
  NopSnapshotQuery,
  NopSnapshotTotalsDto,
  VolumeMatchingItemDto,
} from '@/api/types/overnights';

const NOP = '/api/app/backdated-nop';
const LP = '/api/app/backdated-lp-account';
const EOD = '/api/app/backdated-expected-eod-swap';

export const backdatedEodSwapApi = {
  getCalculated: (q: NopSnapshotQuery) =>
    http.get<ExpectedEodSwapSnapshotDto>(`${EOD}/calculated`, { params: q }).then((r) => r.data),
  exportUrl: (snapshotId: number) => `${EOD}/export/${snapshotId}`,
};

export const backdatedNopApi = {
  getSnapshots: (snapshotDate?: string | null) =>
    http.get<PagedResult<NopDailySnapshotListDto>>(`${NOP}/snapshots`, { params: { skipCount: 0, maxResultCount: 200, snapshotDate: snapshotDate || undefined } }).then((r) => r.data),
  getNopSnapshot: (q: NopSnapshotQuery) =>
    http.get<PagedResult<NopSnapshotDto>>(`${NOP}/nop-snapshot`, { params: q }).then((r) => r.data),
  getTotals: (q: NopSnapshotQuery) => http.get<NopSnapshotTotalsDto>(`${NOP}/totals`, { params: q }).then((r) => r.data),
  getNotifications: (q: NopSnapshotQuery) => http.get<NopSnapshotNotificationsDto>(`${NOP}/notifications`, { params: q }).then((r) => r.data),
  getVolumeMatching: (q: NopSnapshotQuery) =>
    http.get<PagedResult<VolumeMatchingItemDto>>(`${NOP}/volume-matching`, { params: q }).then((r) => r.data),
  recalculate: (snapshotId: number) => http.post(`${NOP}/recalculate-eod-data/${snapshotId}`).then((r) => r.data),
};

export const backdatedLpApi = {
  getSnapshots: (snapshotDate?: string | null) =>
    http.get<PagedResult<DailySnapshotListDto>>(`${LP}/snapshots`, { params: { skipCount: 0, maxResultCount: 200, snapshotDate: snapshotDate || undefined } }).then((r) => r.data),
  getLpAccountSnapshot: (snapshotId: number) =>
    http.get<PagedResult<LPAccountSnapshotDto>>(`${LP}/l-pAccount-snapshot`, { params: { snapshotId, skipCount: 0, maxResultCount: 2000 } }).then((r) => r.data),
  getTotals: (snapshotId: number) => http.get<LPAccountTotalsDto>(`${LP}/totals`, { params: { snapshotId } }).then((r) => r.data),
  getLpEodPositions: (snapshotId: number) =>
    http.get<PagedResult<LpEodPositionDto>>(`${LP}/l-pEod-positions`, { params: { snapshotId, skipCount: 0, maxResultCount: 2000 } }).then((r) => r.data),
};
